module.exports = __webpack_public_path__ + "img/un.71cca596.svg";